/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from 'three';
import { TextureLoader } from 'three';
import { useThree, useLoader } from '@react-three/fiber';

import { MetalStripeImg } from '../../../../../../utils/Textures';
import { delModel, extrudeSettings, textureAnisotropy } from '../../../../../../utils/Functions';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const InsideWallModel = () => {
    const { gl } = useThree();

    const [wallHeight, setWallHeight] = useState(params.p_h);

    const offsetWithDoorThickness = 0.145
    const texture = const_var.metalTexture;

    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        model.moveTo(-(params.p_d / 2 + offsetWithDoorThickness), wallHeight - 0.02);
        model.lineTo(params.p_d / 2 + offsetWithDoorThickness, wallHeight - 0.02);
        model.lineTo(params.p_d / 2 + offsetWithDoorThickness, 0.01);
        model.lineTo(-(params.p_d / 2 + offsetWithDoorThickness), 0.01);
        model.closePath()

        return model;
    
    }, [params.p_d, wallHeight])

    // const CSGWallModel = useMemo(() => {
    //     let model = new THREE.Shape();

    //     model.moveTo(-(params.p_d / 2 - offsetWithDoorThickness), wallHeight - 0.02);
    //     model.lineTo(params.p_d / 2 - offsetWithDoorThickness, wallHeight - 0.02);
    //     model.lineTo(params.p_d / 2 - offsetWithDoorThickness, 0.01);
    //     model.lineTo(-(params.p_d / 2 - offsetWithDoorThickness), 0.01);
    //     model.closePath()

    //     /************** cutting hole using CSG ***************/

    //     const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(model, extrudeSettings(0.005)))
    //     const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftStorageFront', 'wall'), extrudeSettings(1)))

    //     let meshWallModel_Temp = meshWallModel.clone();
    //     let meshDelModel_Temp = meshDelModel.clone();
    //     meshDelModel_Temp.position.set(0, 0, -0.5);

    //     const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
    //     const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

    //     const wallModel_CSG =  meshWallModel_CSG.subtract(meshDelModel_CSG);
    //     const CSGWallModel = CSG.toMesh(
    //         wallModel_CSG,
    //         new THREE.Matrix4()
    //     )

    //     /****************************************** *********/

    //     return CSGWallModel;
    
    // }, [params.p_d, wallHeight])

    const CSGWallModelGeometry = useMemo(() => {
        /************** cutting hole using CSG ***************/
    
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(0.005)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftStorageFront', 'wall'), extrudeSettings(1)))
        const meshFrontOffsetWithDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)))
        const meshBackOffsetWithDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('back', 'wall'), extrudeSettings(1)))

        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.rotateY(Math.PI / 2);
        meshWallModel_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.0025, 0, 0)
        meshWallModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.0025 - 0.5 , 0, 0);
        meshDelModel_Temp.rotateY(Math.PI / 2);
        meshDelModel_Temp.updateMatrixWorld();

        let meshFrontOffsetWithDoorDelModel_Temp = meshFrontOffsetWithDoorDelModel.clone();
        meshFrontOffsetWithDoorDelModel_Temp.position.set(0, 0, params.p_d / 2 - 0.05);
        meshFrontOffsetWithDoorDelModel_Temp.updateMatrixWorld()

        let meshBackOffsetWithDoorDelModel_Temp = meshBackOffsetWithDoorDelModel.clone();
        meshBackOffsetWithDoorDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + 0.95));
        meshBackOffsetWithDoorDelModel_Temp.updateMatrixWorld()

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshFrontOffsetWithDoorDelModel_CSG = CSG.fromMesh(meshFrontOffsetWithDoorDelModel_Temp);
        const meshBackOffsetWithDoorDelModel_CSG = CSG.fromMesh(meshBackOffsetWithDoorDelModel_Temp);

        const meshWall_CSG =  meshWallModel_CSG.subtract(meshDelModel_CSG);
        const frontWallModel_CSG =  meshWall_CSG.subtract(meshFrontOffsetWithDoorDelModel_CSG);
        const backWallModel_CSG =  frontWallModel_CSG.subtract(meshBackOffsetWithDoorDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            backWallModel_CSG,
            new THREE.Matrix4()
        )

            return CSGWallModel.geometry
    }, [wallModel, const_var.newDoorsArray, parseInt(params.cB_addStorage_left), params.p_w, params.p_d])


    useMemo(() => {
        let overHeight = 0;
        const height = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) : params.p_h;
        
        if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || ((params.singleSlope && params.freeStandingSide === "left") || params.freeStandingSide === "right")) {
            if (params.p_r_s === 1) {
                overHeight = (parseInt(params.cB_addStorage_left) - 0.0075) * params.p_r_p / 12 + 0.4;
            } else {
                overHeight = (parseInt(params.cB_addStorage_left) - 0.0075) * params.p_r_p / 12;
            }
        } else {
            if (params.p_r_s === 1) {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_left) - 0.0075) * params.p_r_p / 12 + 0.4;
            } else {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_left) - 0.0075) * params.p_r_p / 12;
            }
        }

        setWallHeight(height + overHeight);
    
    }, [params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, params.singleSlope, params.freeStandingSide, params.p_h])

    /****************************************** *********/

    useMemo(() => {
        textureAnisotropy(gl, texture, 1.3, 1.3, params.p_v_w ? Math.PI / 2 : 0);    
    }, [params.p_v_w])


    return CSGWallModelGeometry && (
        <group onPointerOver={e => e.stopPropagation()} onPointerDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()} >
            <mesh name="left-storage-inside-wall" geometry={CSGWallModelGeometry} position={[-0.01, 0, 0]}>
                <meshBasicMaterial map={texture}  side={THREE.DoubleSide} color={"#C9C9C9"}  transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02}/>
            </mesh>
        </group>
    )
}

export default InsideWallModel